import { Injectable } from '@angular/core';
import { posthog, PostHog } from 'posthog-js';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  private trackingEnabled: boolean = false;
  private lastCapturedPath?: string;
  private identifiedId?: string;
  private ph: PostHog;

  constructor() {
    this.ph = (posthog as any).main;
  }

  identifyUser(userId: string, details: any) {
    const isNewIdentity = this.identifiedId !== userId;

    // Switching between different known users/visitors — clear the previous identity first.
    if (isNewIdentity && this.identifiedId) {
      this.ph.reset();
      this.lastCapturedPath = undefined;
    }

    this.ph.identify(userId, details);
    this.identifiedId = userId;
    this.ph.set_config({ capture_pageview: true, autocapture: true });
    this.trackingEnabled = true;

    // Only capture the initial pageview when establishing a new identity.
    // Property-only refreshes for the same user should not mint a new anon session.
    if (isNewIdentity) {
      this.lastCapturedPath = this.getCurrentPath();
      this.ph.capture('$pageview');
    }
  }

  reset() {
    this.ph.reset();
    this.ph.set_config({ capture_pageview: false, autocapture: false });
    this.trackingEnabled = false;
    this.lastCapturedPath = undefined;
    this.identifiedId = undefined;
  }

  capturePageviewIfEnabled(path?: string) {
    if (!this.trackingEnabled) return;
    const currentPath = path ?? this.getCurrentPath();
    if (currentPath === this.lastCapturedPath) return;
    this.lastCapturedPath = currentPath;
    this.ph.capture('$pageview');
  }

  private getCurrentPath(): string {
    return window.location.pathname + window.location.search + window.location.hash;
  }
}
